/**
 * Textarea "una línea por ítem" ⇄ `string[]`. Entrada `lines-text` del catálogo:
 * antes había la misma pareja copiada en los 6 diálogos del Partnerships Hub
 * (13/10/2026). Vacías y espacios de más se descartan; no hay NFD ni mayúsculas.
 */
export const toLines = (arr?: readonly string[] | null): string => (arr ?? []).join('\n');

export const fromLines = (s: string | null | undefined): string[] =>
  (s ?? '').split('\n').map((l) => l.trim()).filter(Boolean);
